import React, { createContext, useContext, useState } from "react";

const EvModeContext = createContext({ evMode: false, setEvMode: () => {} });

export function EvModeProvider({ children }) {
  const [evMode, setEvMode] = useState(false);
  return (
    <EvModeContext.Provider value={{ evMode, setEvMode }}>
      {children}
    </EvModeContext.Provider>
  );
}

export function useEvMode() {
  return useContext(EvModeContext);
}
